import getApi from '../../api'

export const deleteDocumentLayout = (id: number) => getApi().delete<void>(`/document_layouts/${id}`)
